import React, { memo } from "react";
import "./Footer.css";

const Footer = memo(function Footer({ theme }) {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-left">
          <span className="footer-brand">PULSE</span>
          <span className="footer-divider">|</span>
          <span className="footer-copy">
            @SWOTS-CIA
          </span>
        </div>

        <div className="footer-right">
          <a href="#wiki" className="footer-link">
            Wiki
          </a>
          <a href="#outlook" className="footer-link">
            Outlook
          </a>
          <a href="#slack" className="footer-link">
            Slack
          </a>
        </div>
      </div>
    </footer>
  );
});

export default Footer;
